<template>
  <div>
    <components
      :is="currentMode"
      :checkDailyCalculateRes="checkDailyCalculateRes"
      :hasQualification="hasQualificationObj"
    />
    <CheckSpillover
      :open="CheckSpilloverPopup"
      :message="CheckSpilloverMessage"
      @close="closeCheckSpillover()"
    ></CheckSpillover>
  </div>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import print_TD from "@/desktop/views/mf/components/2.Query/2-5-1.PrintProposal/print_TD.vue";
import print_IV from "@/desktop/views/mf/components/2.Query/2-5-1.PrintProposal/print_IV.vue";
import print_IUL from "@/desktop/views/mf/components/2.Query/2-5-1.PrintProposal/print_IUL.vue";
import print_TD_PAR from "@/desktop/views/mf/components/2.Query/2-5-1.PrintProposal/print_TD_PAR.vue";
import CheckSpillover from "@/desktop/views/mf/components/2.Query/2-5-1.PrintProposal/CheckSpillover.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  mixins: [mf_Mixin],
  components: { print_TD, print_IV, print_IUL, print_TD_PAR, CheckSpillover },
  data() {
    return {
      currentMode: "print_TD",
      ready: false,
      CheckSpilloverPopup: false,
      CheckSpilloverMessage: "",
      checkDailyCalculateRes: false,
      hasQualificationObj: {},
    };
  },
  computed: {
    ...mapGetters(["CustInfo", "UserInfo", "MfViewing"]),
  },
  async mounted() {
    if (!this.MfViewing.prod_idx) {
      return this.$router.push("/mf/query");
    }
    this.updateClickDate();

    // 依據最初在 2-3.QueryDetail.vue 的 prod_type 及 isDividend 取得對應的元件
    const { prod_type, isDividend } = this.MfViewing.saveData;
    this.currentMode =
      prod_type === "1" && isDividend
        ? "print_TD_PAR"
        : prod_type === "1"
        ? "print_TD"
        : prod_type === "5"
        ? "print_IUL"
        : "print_IV";

    //開始進行檢核
    this.hasQualificationObj = await this.inquireQualificationByKind4CSR(
      this.MfViewing.saveData.mc_prod_list,
      true
    );

    if (this.hasQualificationObj.hasQualification) {
      let result = this.$store.getters.proRiskObj; // riskObj物件
      // 是否有kyc 訊息
      let kycMixinMsg = this.insuredRiskWarnText(
        this.MfViewing.insurer.insured_id,
        "printTitle",
        result
      );
      if (this.MfViewing.saveData.prod_type !== "1" && this.MfViewing.saveData.prod_type !== "5" && kycMixinMsg !== "") {
        this.$mfNotice(
          "",
          () => {
            this.check();
          },
          false,
          null,
          "確定",
          `
            <strong style='font-size:20px'>${this.insuredRiskWarnText(
              this.MfViewing.insurer.insured_id,
              "printTitle",
              result
            )}</strong>
            <br /><br />
            <br />
            <div style='font-size:20px'>${this.insuredRiskWarnText(
              this.MfViewing.insurer.insured_id,
              "print",
              result
            )}</div>
            `
        );
      } else {
        this.check();
      }
    } else {
      if (this.currentMode == "print_IV") {
        //檢核日額通算
        this.checkDailyCalculateRes = await this.checkDailyCalculate({
          insured_age: this.MfViewing.saveData.insured_age,
          mc_prod_list: this.MfViewing.saveData.mc_prod_list,
        });
      }
      if (this.currentMode == "print_IUL") {
        //檢核日額通算
        this.checkDailyCalculateRes = await this.checkDailyCalculate({
          insured_age: this.MfViewing.saveData.insured_age,
          mc_prod_list: this.MfViewing.saveData.mc_prod_list,
        });
      }
    }
  },
  methods: {
    async check() {
      if (this.currentMode == "print_IV") {
        //檢核日額通算
        this.checkDailyCalculateRes = await this.checkDailyCalculate({
          insured_age: this.MfViewing.saveData.insured_age,
          mc_prod_list: this.MfViewing.saveData.mc_prod_list,
        });
      }
      if (this.currentMode == "print_IUL") {
        //檢核日額通算
        this.checkDailyCalculateRes = await this.checkDailyCalculate({
          insured_age: this.MfViewing.saveData.insured_age,
          mc_prod_list: this.MfViewing.saveData.mc_prod_list,
        });
      }
    },
    closeCheckSpillover() {
      this.CheckSpilloverPopup = false;
      //   if (
      //     this.MfViewing.saveData.prod_type != "1" ||
      //     this.$store.getters.BuTest
      //   ) {
      //     this.$mfNotice(
      //       "",
      //       null,
      //       false,
      //       null,
      //       "確定",
      //       `
      //   <strong style='font-size:20px'>請注意!商品列印建議書功能目前僅供內部試用!</strong>
      // <br /><br />
      // <br />
      // <div class="text-underline" style='font-size:20px'>請勿對外流出或用於行銷用途</div>
      //   `
      //     );
      //   }
    },
  },
};
</script>
<style lang="scss"></style>
